module.exports = __webpack_public_path__ + "media/kick.4dd58595.wav";